import React, { useRef, Children } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
const badgeVariants = {
  hidden: {
    opacity: 0,
    scale: 0.8
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.4
    }
  }
};
export function MechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const badges = ['Truly Invisible', 'Fireproof', 'Unbreakable', 'Off the Books'];
  return <section ref={ref} className="relative w-full bg-dark-section py-20 md:py-28 overflow-hidden" data-id="element-167">
      {/* Blueprint grid accent on right side */}
      <div className="absolute top-0 right-0 w-1/2 h-full blueprint-grid opacity-50" data-id="element-168" />

      <div className="relative z-10 max-w-4xl mx-auto px-6" data-id="element-169">
        {/* Orange label */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5
      }} className="mb-4" data-id="element-170">
          <span className="inline-block px-3 py-1 text-xs font-inter font-bold tracking-[0.2em] text-orange-accent uppercase border border-orange-accent/50 bg-orange-accent/10" data-id="element-171">
            THE SOLUTION
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h2 className="font-bebas text-4xl md:text-5xl lg:text-6xl text-white mb-8 tracking-wide" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-172">
          THE <span className="text-orange-accent" data-id="element-173">INVISIBLE ANCHOR</span>{' '}
          METHOD
        </motion.h2>

        {/* Body text */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-12" data-id="element-174">
          <p className="font-inter text-lg md:text-xl text-concrete leading-relaxed mb-6" data-id="element-175">
            This isn't a book about "buying" security. It's a manual for{' '}
            <span className="text-white font-semibold" data-id="element-176">building</span> it.
          </p>
          <p className="font-inter text-lg text-concrete leading-relaxed mb-6" data-id="element-177">
            Using the same structural principles used by high-end architects and
            Tier 1 contractors, you'll learn how to use{' '}
            <span className="text-orange-accent font-semibold" data-id="element-178">
              $500 in basic hardware store materials
            </span>{' '}
            to create a vault that's integrated directly into your home's
            foundation or walls.
          </p>
          <p className="font-inter text-lg text-concrete leading-relaxed" data-id="element-179">
            It can't be removed without taking the house with it. It can't be
            found without knowing exactly where to look. And it leaves{' '}
            <span className="text-white font-semibold" data-id="element-180">zero paper trail</span>.
          </p>
        </motion.div>

        {/* Feature badges */}
        <motion.div className="flex flex-wrap gap-4" variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} data-id="element-181">
          {badges.map(badge => <motion.span key={badge} variants={badgeVariants} className="px-5 py-3 font-inter font-semibold text-sm text-white uppercase tracking-wider border-2 border-orange-accent bg-dark-card" data-id="element-182">
              {badge}
            </motion.span>)}
        </motion.div>
      </div>
    </section>;
}